// src/screens/Result.js
const SEV = {
  low:      { color: 'var(--sev-low)',  bg: 'var(--sev-low-bg)',  label: 'Baja',    bars: 1 },
  medium:   { color: 'var(--sev-med)',  bg: 'var(--sev-med-bg)',  label: 'Media',   bars: 2 },
  high:     { color: 'var(--sev-high)', bg: 'var(--sev-high-bg)', label: 'Alta',    bars: 3 },
  critical: { color: 'var(--sev-crit)', bg: 'var(--sev-crit-bg)', label: 'Crítica', bars: 4 },
};

const URG = {
  deferred:  { color: 'var(--sev-low)',  label: 'Diferida · >12 meses' },
  planned:   { color: 'var(--sev-med)',  label: 'Planificada · 3–12 meses' },
  immediate: { color: 'var(--sev-high)', label: 'Inmediata · <3 meses' },
  emergency: { color: 'var(--sev-crit)', label: 'Emergencia · <48 horas' },
};

function sevBars(severity) {
  const s = SEV[severity] || SEV.medium;
  const bars = [1,2,3,4].map(i =>
    `<div class="sev-bar" style="background:${i <= s.bars ? s.color : 'var(--border)'}"></div>`
  ).join('');
  return `
    <div style="display:flex;align-items:center;gap:8px">
      <div class="sev-bars">${bars}</div>
      <div style="font-size:14px;font-weight:500;color:${s.color}">${s.label}</div>
    </div>`;
}

export function ResultScreen(container, state, actions) {
  const d = state.diagnosis;
  if (!d) { actions.navigate('capture'); return; }

  const s = SEV[d.severity] || SEV.medium;
  const u = URG[d.urgency]  || URG.planned;

  // Normalise steps — they may come from the JSON as an array or nested object
  const steps = Array.isArray(d.repair?.procedure?.es)
    ? d.repair.procedure.es
    : Array.isArray(d.repair_steps_es) ? d.repair_steps_es : [];

  const premiumProduct = d.materials?.premium?.product || d.premium_product || '';
  const premiumNote    = d.materials?.premium?.note?.es || d.premium_note_es || '';
  const genericMat     = d.materials?.generic?.es || d.generic_material_es || '';

  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div></div>
        </div>
        <div class="sponsor-badge"><i class="ti ti-star" aria-hidden="true" style="font-size:9px"></i> Sika</div>
      </div>
      <div class="screen-body">
        <button class="btn-back" id="btn-back"><i class="ti ti-arrow-left" aria-hidden="true"></i> Nuevo diagnóstico</button>

        <!-- Header -->
        <div class="card" style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px">
          <div style="flex:1;min-width:0">
            <div class="card-label">Patología detectada</div>
            <div style="font-size:17px;font-weight:500;line-height:1.2">
              ${d.pathology_name?.es || d.pathology_name_es || 'Patología detectada'}
            </div>
            <div class="mono" style="font-size:10px;color:var(--amber);margin-top:4px">${d.norm || '—'}</div>
          </div>
          <div style="background:var(--bg-card2);border:1px solid var(--border2);border-radius:var(--r-md);padding:9px 13px;text-align:center;flex-shrink:0">
            <div class="mono" style="font-size:20px;color:var(--amber)">${d.confidence || 0}%</div>
            <div class="mono" style="font-size:9px;color:var(--muted);text-transform:uppercase;letter-spacing:.1em">Confianza</div>
          </div>
        </div>

        <!-- Severity + Urgency -->
        <div class="grid-2">
          <div class="card" style="margin-bottom:0">
            <div class="card-label">Severidad</div>
            ${sevBars(d.severity)}
          </div>
          <div class="card" style="margin-bottom:0">
            <div class="card-label">Urgencia</div>
            <div style="font-size:12px;font-weight:500;color:${u.color};line-height:1.4">${u.label}</div>
          </div>
        </div>

        <!-- Root cause -->
        <div class="card">
          <div class="card-label">Causa raíz probable</div>
          <div style="font-size:13px;color:var(--dim);line-height:1.5">
            ${d.root_cause?.es || d.root_cause_es || '—'}
          </div>
        </div>

        <!-- Repair procedure -->
        <div class="card">
          <div class="card-label">Procedimiento de reparación</div>
          <div class="mono" style="font-size:9px;color:var(--muted);margin-bottom:8px">
            ${d.repair?.norm_reference || d.norm_reference || '—'}
          </div>
          <ul class="repair-list">
            ${steps.map((step, i) => `
              <li class="repair-item">
                <span class="repair-num">0${i + 1}</span>
                <span style="color:var(--dim)">${step}</span>
              </li>`).join('')}
          </ul>
        </div>

        <!-- Materials -->
        <div class="grid-2">
          <div class="card" style="margin-bottom:0">
            <div class="card-label">Genérico</div>
            <div style="font-size:12px;color:var(--dim);line-height:1.4">${genericMat || '—'}</div>
          </div>
          <div class="card card--amber" style="margin-bottom:0">
            <div class="card-label card-label--amber">
              <i class="ti ti-star" aria-hidden="true" style="font-size:9px"></i> Sika premium
            </div>
            <div style="font-size:12px;font-weight:500;color:var(--amber-dark)">${premiumProduct || '—'}</div>
            ${premiumNote ? `<div style="font-size:11px;color:var(--amber);margin-top:4px;line-height:1.4">${premiumNote}</div>` : ''}
          </div>
        </div>

        <!-- Actions -->
        <div class="action-row" style="margin-top:14px">
          <button class="action-btn" id="btn-pdf">
            <i class="ti ti-file-description" aria-hidden="true"></i> Ver PDF
          </button>
          <button class="action-btn" id="btn-linkedin">
            <i class="ti ti-brand-linkedin" aria-hidden="true"></i> LinkedIn
          </button>
          <button class="action-btn" id="btn-new">
            <i class="ti ti-refresh" aria-hidden="true"></i> Nuevo
          </button>
        </div>
      </div>
    </div>`;

  container.querySelector('#btn-back')?.addEventListener('click', () => {
    actions.navigate('capture', { image: null, diagnosis: null });
  });
  container.querySelector('#btn-pdf')?.addEventListener('click', () => actions.navigate('pdf_preview'));
  container.querySelector('#btn-linkedin')?.addEventListener('click', () => actions.navigate('linkedin'));
  container.querySelector('#btn-new')?.addEventListener('click', () => {
    actions.navigate('capture', { image: null, diagnosis: null, error: null });
  });
}
